import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    plotError: '',      
    plotSignal: {},
    plotStrategies: [],  
    signalsData: [],  
};

const simulationPlotSlicer = createSlice({
  name: 'simulationPlot',
  initialState,
  reducers: {
    setPlotError: (state, action) => {
      state.plotError = action.payload;
    },          
    setPlotSignal: (state, action) => {
      state.plotSignal = action.payload;
    },        
    setPlotStrategies: (state, action) => {
      state.plotStrategies = action.payload;
    },    
    setSignalsData: (state, action) => {
      state.signalsData = action.payload;
    },    
  },
});

export const { setPlotError, setPlotSignal, setPlotStrategies, setSignalsData } = simulationPlotSlicer.actions;
export default simulationPlotSlicer.reducer;